import { jsPDF } from "jspdf";
import logoOC from '../../logo/ocean_logo2.png';
import { pageShort } from '../layout/pdfFormat';
import { toDataURL } from '../../Functions';
import { CargoTransferSlipHeaDCompose, CargoTransferSlipHeadingCompose, CargoTransferSlipContentCompose, CargoTransferSlipClosingCompose,} from './CTSContent';

export function CTS(Data) {
    toDataURL(logoOC)
        .then(dataUrl => {
            var dataDoc = new jsPDF(pageShort.layout, pageShort.papersize.unit, pageShort.papersize.format);
            var rowL = pageShort.margin.top;

            dataDoc.setProperties({
                title: 'Cargo Transfer Slip',
                subject: 'CTS',
                creator: 'OTGCI'
            });

            dataDoc.setFont("courier", "normal");
            dataDoc.setFontSize(11);
            dataDoc.setFont("times", "bold");
            rowL = CargoTransferSlipHeaDCompose(pageShort, rowL, dataDoc, dataUrl);
            rowL = CargoTransferSlipHeadingCompose(pageShort, rowL, dataDoc, Data.header);
            rowL = CargoTransferSlipContentCompose(pageShort, rowL, dataDoc, Data);
            CargoTransferSlipClosingCompose(pageShort, rowL, dataDoc, Data.user);
            dataDoc.setFont("times", "normal");

            // dataDoc.autoPrint();
            window.open(dataDoc.output('bloburl'), '_blank');

        })
}